import React from "react";
import { Component } from "react";
import { InputField } from "../../../common/custom-form/input-filter-component";
import Icons from "../../../icon";
import { Button } from "react-bootstrap";
import { DetailsDataTable } from "./details-table/details-table.component";
export class AddCostAllocation extends Component {
    constructor(props) {
        super(props);
        this.state={
            inputValue:"",
            showTable:false,
        }
    }
    ShowTable() {
        this.setState({showTable:!this.showTable})
    }
    render() {
        return(
            <div className="">
                <div className="details-4-col-container">
                <InputField label="CIRCUIT ID" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})} />
                <InputField label="COST CENTER" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})} />
                <InputField label="PERCENT" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})} />
                <div className="add-button-container ">
                    <Button>Cancel</Button>
                    <Button onClick={this.ShowTable.bind(this)}>Add</Button>
                </div>                
            </div>
                {
                    this.state.showTable && 
                    <DetailsDataTable datatable={this.props.datatable} haveEditBtn={this.props.haveEditBtn} haveDeleteBtn={this.props.haveDeleteBtn} />       
                }
         </div>
        );
    }
}